<div class="flex flex-col gap-4 bg-gradient-to-br to-transparent from-lGray400/60 rounded-3xl p-4 shadow-lg border border-lGray600 backdrop-blur-sm">
  <div class="relative h-[410px] w-full rounded-2xl overflow-hidden">
    <img [src]="track.coverImageUrl || 'assets/images/course-default.png'" [alt]="track.name || 'Trilha'" class="w-full h-full" />

    <div class="absolute inset-0 bg-gradient-to-t from-black to-transparent"></div>
    
    <span class="absolute bottom-4 left-4 text-white text-xl font-semibold">{{ track.name }}</span>
  </div>
  
  
  <button lButton [bRadius]="buttonRadiusEnum.LARGE" (click)="navigateToTrack()">Ver mais</button>
</div>
